export const paths = {
  REQUEST_CONFIRMATION: 'confirm',
  PASSWORD: 'password',
  CONFIRMATION: 'confirmation',
}

export const deleteAccountLinks = {
  deleteAccountConfirmationLink: () => `/${paths.CONFIRMATION}`,
  deleteAccountPasswordLink: () => `/${paths.PASSWORD}`,
  deleteAccountRequestConfirmationLink: () => `/${paths.REQUEST_CONFIRMATION}`,
}

export type DeleteAccountLinks = typeof deleteAccountLinks
